export default "__VITE_ASSET__BNF7QBNe__"